import AGREGAR_CATALOGO_INFRAESTRUCTURA_SUBTIPO from '@/graphql/mutations/administracion/catalogos/infraestructurasubtipos/agregarCatalogoInfraestructuraSubtipo.gql';
import REMOVER_CATALOGO_INFRAESTRUCTURA_SUBTIPO from '@/graphql/mutations/administracion/catalogos/infraestructurasubtipos/removerCatalogoInfraestructuraSubtipo.gql';
import ACTUALIZAR_CATALOGO_INFRAESTRUCTURA_SUBTIPO from '@/graphql/mutations/administracion/catalogos/infraestructurasubtipos/actualizarCatalogoInfraestructuraSubtipo.gql';
import CATALOGO_INFRAESTRUCTURA_TIPOS from '@/graphql/querys/administracion/catalogos/infraestructurastipos/catalogoInfraestructuraTipos.gql';
import CATALOGO_INFRAESTRUCTURA_SUBTIPOS from '@/graphql/querys/administracion/catalogos/infraestructurasubtipos/catalogoInfraestructuraSubtipos.gql';

export default {
  apollo: {
    catalogoInfraestructuraTipos: {
      query: CATALOGO_INFRAESTRUCTURA_TIPOS,
    },
  },
  methods: {
    // Agregar Subtipo Infraestructura
    async mixAgregarSubtipoInfraestructura() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CATALOGO_INFRAESTRUCTURA_SUBTIPO,
          variables: {
            subtipoInfraestructura: this.subtipoInfraestructura,
          },
          update: (store, { data: { agregarCatalogoInfraestructuraSubtipo } }) => {
            const query = {
              query: CATALOGO_INFRAESTRUCTURA_SUBTIPOS,
            };
            const { catalogoInfraestructuraSubtipos } = store.readQuery(query);
            const catalogoInfraestructuraSubtiposCopia = catalogoInfraestructuraSubtipos.slice();
            catalogoInfraestructuraSubtiposCopia.push(agregarCatalogoInfraestructuraSubtipo);
            store.writeQuery({
              ...query,
              data: {
                catalogoInfraestructuraSubtipos: catalogoInfraestructuraSubtiposCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Editar Subtipo Infraesatructura
    async mixActualizarSubtipoInfraestructura() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CATALOGO_INFRAESTRUCTURA_SUBTIPO,
          variables: {
            id: this.subtipoInfraestructuraEditar.id,
            subtipoInfraestructura: this.subtipoInfraestructura,
          },
          update: (store, { data: { actualizarCatalogoInfraestructuraSubtipo } }) => {
            const query = {
              query: CATALOGO_INFRAESTRUCTURA_SUBTIPOS,
            };
            const data = store.readQuery(query);
            const { catalogoInfraestructuraSubtipos } = data;
            const index = catalogoInfraestructuraSubtipos
              .findIndex((catalogoInfraestructuraSubtipo) => catalogoInfraestructuraSubtipo.id
              === actualizarCatalogoInfraestructuraSubtipo.id);
            if (index !== -1) {
              catalogoInfraestructuraSubtipos
                .splice(index, 1, actualizarCatalogoInfraestructuraSubtipo);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Subtipo Infraestructura
    async mixEliminarSubtipoInfraestructura() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CATALOGO_INFRAESTRUCTURA_SUBTIPO,
        variables: {
          id: this.subtipoInfraestructuraEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CATALOGO_INFRAESTRUCTURA_SUBTIPOS,
          };
          const data = store.readQuery(query);
          const { catalogoInfraestructuraSubtipos } = data;
          const index = catalogoInfraestructuraSubtipos
            .findIndex((catalogoInfraestructuraSubtipo) => catalogoInfraestructuraSubtipo.id
            === this.subtipoInfraestructuraEliminar.id);
          if (index !== -1) {
            catalogoInfraestructuraSubtipos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
  computed: {
    getTiposInfraestructura() {
      if (!this.catalogoInfraestructuraTipos) return [];
      return this.catalogoInfraestructuraTipos;
    },
  },
};
